import {Component} from '@angular/core';

@Component({
	           selector: 'app-language-redirect',
	           template: '',
	           standalone: true
           })
export class LanguageRedirectComponent {}
